var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "prep-info", class: { invisible: _vm.hide } },
    [
      _c("span", { staticClass: "icon", class: [_vm.icon] }),
      _vm._v("\n  " + _vm._s(_vm._f("minMax")(_vm.display, " - "))),
      _c("span", { domProps: { innerHTML: _vm._s(_vm.unit) } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0556893a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0556893a","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./src/components/min-max/min-max.html
// module id = 132
// module chunks = 0